<template>
  <div class="registrar bg-[#00554A] mt-[10px] py-[30px] px-[10px] h-full">
    <div class="text-[11px] color-[#FFFFFF]">{{ $t('convidarCentro.registerSub.title') }}</div>
    <div class="auth-input-row mt-[30px]" :class="{ 'input-error': registerPhoneError }">
      <img :src="getAssetsFile('home/yignud.png')" alt="" class="h-[20px] w-[20px]">
      <div style="width: 0px;border:1px solid #ffffff;height:15px;margin-left: 5px;" />
      <div class="color-white text-[11px] ml-[5px]">
        +{{ VITE_AREA_CODE }}
      </div>
      <input v-model="registerForm.phone" class="auth-input ml-[5px] "
        :placeholder="$t('convidarCentro.registerSub.phone')" @input="onRegisterPhoneInput">
      <img v-if="registerForm.phone" :src="getAssetsFile('home/closes.png')" alt=""
        class="h-[11px] w-[11px] cursor-pointer" @click="registerForm.phone = ''">
    </div>
    <div v-if="registerPhoneError" class="input-error-tip relative top-[5px] left-[0px]">
      <img :src="getAssetsFile('home/@2x.png')" alt="" class="h-[11px] w-[11px]">
      {{ $t('convidarCentro.registerSub.invalidPhone') }}
    </div>
    <div class="auth-input-row mt-[30px]">
      <input v-model="registerForm.password" class="auth-input" :type="showRegisterPassword ? 'text' : 'password'"
        :placeholder="$t('convidarCentro.registerSub.password')" @input="onPasswordInput">
      <img v-if="registerForm.password" :src="getAssetsFile('home/closes.png')" alt="" class="h-[11px] w-[11px]"
        @click="registerForm.password = ''">
      <img v-if="showRegisterPassword" :src="getAssetsFile('home/Preview@2x.png')" alt=""
        class="h-[11px] w-[11px] ml-[10px] cursor-pointer" style="object-fit: contain;" @click="toggleRegisterPassword">
      <img v-if="!showRegisterPassword" :src="getAssetsFile('home/Preview@2x (1).png')" alt=""
        class="h-[11px] w-[11px] ml-[10px] cursor-pointer" style="object-fit: contain;" @click="toggleRegisterPassword">
    </div>
    <div v-if="showPasswordTip" class="input-error-tip relative top-[5px] left-[0px]">
      <img :src="getAssetsFile('home/@2x.png')" alt="" class="h-[11px] w-[11px] ml-[2px]">
      {{ $t('convidarCentro.registerSub.passwordTip') }}
    </div>
    <div class="auth-input-row mt-[20px]">
      <input v-model="registerForm.confirmPassword" class="auth-input" :type="showConfirmPassword ? 'text' : 'password'"
        :placeholder="$t('convidarCentro.registerSub.confirmPassword')">
      <img v-if="registerForm.confirmPassword" :src="getAssetsFile('home/closes.png')" alt="" class="h-[11px] w-[11px]"
        @click="registerForm.confirmPassword = ''">
      <img v-if="showConfirmPassword" :src="getAssetsFile('home/Preview@2x.png')" alt=""
        class="h-[11px] w-[11px] ml-[10px] cursor-pointer" style="object-fit: contain;" @click="toggleConfirmPassword">
      <img v-if="!showConfirmPassword" :src="getAssetsFile('home/Preview@2x (1).png')" alt=""
        class="h-[11px] w-[11px] ml-[10px] cursor-pointer" style="object-fit: contain;" @click="toggleConfirmPassword">
    </div>
    <div class="mt-[28px] flex justify-center items-center">
      <Button type="medium" @click="Criars">
        {{ $t('convidarCentro.registerSub.create') }}
      </Button>
    </div>
  </div>
</template>
<script setup lang="ts">
import { Button } from '@/components/Button';
import { ref, onMounted } from 'vue';
import { useI18n } from 'vue-i18n';
import * as GameApi from '@/api/game';
import { useUserStore } from '@/stores/modules/user';
import { useAppStore } from '@/stores/modules/app'; // 添加 appStore 导入
import { getAssetsFile, getDeviceFingerprint } from '@/utils/pub-use';

const { t } = useI18n();
const VITE_AREA_CODE = import.meta.env.VITE_AREA_CODE
const registerPhoneError = ref(false)
const rechargeBtnAnimated = ref(false)
const registerForm = ref({
  phone: '',
  password: '',
  confirmPassword: '',
  inviteCode: '',
  areaCode: VITE_AREA_CODE,
  platform: 1, // 添加platform字段，默认为Web平台
});
const userStore = useUserStore()
const appStore = useAppStore() // 添加 appStore 实例
// 修复类型错误：使用可选链操作符
registerForm.value.inviteCode = (userStore.userInfo as any)?.activeCode || ''
const showConfirmPassword = ref(false)
const showPasswordTip = ref(false)
const showRegisterPassword = ref(false)
const showLoginPassword = ref(false)

function onRegisterPhoneInput(e: Event) {
  const val = (e.target as HTMLInputElement).value.replace(/\D/g, '')
  registerForm.value.phone = val
  registerPhoneError.value = !/^\d{4,}$/.test(val)
}

function toggleConfirmPassword() {
  showConfirmPassword.value = !showConfirmPassword.value
}

// 切换密码显示状态
function toggleLoginPassword() {
  showLoginPassword.value = !showLoginPassword.value
}

// 添加密码输入处理
function onPasswordInput() {
  const passwordLength = registerForm.value.password.length
  // 当密码长度达到6位或以上时隐藏提示
  showPasswordTip.value = passwordLength > 0 && passwordLength < 6
}

function toggleRegisterPassword() {
  showRegisterPassword.value = !showRegisterPassword.value
}

onMounted(async () => {
  // 确保获取域名信息，以便获取 channelId
  try {
    console.log('=== onMounted 调试信息 ===')
    console.log('appStore.channelInfo 初始值:', appStore.channelInfo)

    if (!appStore.channelInfo) {
      console.log('channelInfo 为空，调用 getDomainInfo')
      await appStore.getDomainInfo()
      console.log('getDomainInfo 调用后，channelInfo:', appStore.channelInfo)
    } else {
      console.log('channelInfo 已存在，无需调用 getDomainInfo')
    }

    console.log('=== onMounted 调试信息结束 ===')
  } catch (error) {
    console.error('获取域名信息失败:', error)
  }
})

const Criars = async () => {
  rechargeBtnAnimated.value = false
  void rechargeBtnAnimated.value // 强制刷新
  setTimeout(() => { rechargeBtnAnimated.value = true }, 10)
  setTimeout(() => { rechargeBtnAnimated.value = false }, 400);

  try {
    // 获取设备指纹
    const deviceNumber = await getDeviceFingerprint()

    // 获取渠道ID
    const channelId = appStore.channelInfo?.id?.toString() || ''

    // 添加更详细的调试信息
    console.log('=== 调试信息 ===')
    console.log('appStore:', appStore)
    console.log('appStore.channelInfo:', appStore.channelInfo)
    console.log('appStore.channelInfo?.id:', appStore.channelInfo?.id)
    console.log('channelId:', channelId)
    console.log('channelId type:', typeof channelId)
    console.log('channelId length:', channelId.length)

    const submitData = {
      phone: registerForm.value.phone,
      password: registerForm.value.password,
      areaCode: registerForm.value.areaCode,
      platform: registerForm.value.platform,
      inviteCode: registerForm.value.inviteCode,
      deviceNumber, // 添加设备指纹字段
      channelId, // 添加渠道ID字段
      promoter: true,
    }

    console.log('submitData:', submitData)
    console.log('submitData.channelId:', submitData.channelId)
    console.log('=== 调试信息结束 ===')

    await GameApi.userreg(submitData)
    // 清空注册表单
    registerForm.value.phone = ''
    registerForm.value.password = ''
    registerForm.value.confirmPassword = '';
    (window as any).$toast(t('convidarCentro.registerSub.registerSuccess'))
  }
  catch (error) {
    console.error('注册失败:', error)
  }

}
</script>
<style scoped>
.registrar {


  position: fixed;
  top: 95px;

  left: 0;
  right: 0;
  z-index: 1000;
}


.auth-input-row {
  display: flex;
  box-shadow: inset 0px 2px 1px 0px rgba(0, 28, 24, 0.66);
  /* border: 1px solid #50d38c; */
  border-radius: 3px 3px 3px 3px;
  align-items: center;
  background: #11412f;
  display: flex;
  align-items: center;
  padding: 0 11px;
}

.auth-img-placeholder {
  width: 28px;
  height: 28px;
  background: #1a4d3a;
  border-radius: 6px;
  margin-right: 8px;
}

.auth-input {
  flex: 1;
  height: 40px;
  border-radius: 8px;
  border: none;
  padding: 0 12px 0 0;
  background: none;
  color: #fff;
  font-size: 12px;
  caret-color: #50d38c;
}

.input-error-tip {
  display: flex;
  align-items: baseline;
  color: #ff4d4f;
  font-size: 12px;
}

input[type='checkbox'] {
  accent-color: #50d38c;
}

.input-error {
  border: 1px solid #ff4d4f !important;
}

.input-error-tip {
  display: flex;
  align-items: baseline;
  color: #ff4d4f;
  font-size: 12px;
}

.input-tip {
  display: flex;
  align-items: baseline;
  color: #50d38c;
  font-size: 12px;
}

.auth-btn-disabled {
  background: #126736 !important;
  cursor: not-allowed !important;
  opacity: 0.6;
}

.auth-btn:disabled {
  background: #126736 !important;
  cursor: not-allowed !important;
  opacity: 0.6;
}

input::placeholder {
  color: #096;
  font-size: 12px;
}

.Recharge {
  height: 40px;
  background: linear-gradient(180deg, #13C769 0%, #1C9755 100%);
  box-shadow: 1px 1px 2px 0px rgba(21, 76, 55, 0.32);
  border-radius: 6px;
  color: #FFFFFF;
  font-size: 12px;
  font-weight: bold;
  text-align: center;
  line-height: 40px;
  position: relative;
  overflow: hidden;
  width: 80%;
  margin: 0 auto;
  margin-top: 25px;
}

.Recharge::before {
  content: '';
  position: absolute;
  left: 50%;
  top: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(90deg, #fff 0%, #43C36B 50%, #fff 100%);
  opacity: 0.25;
  border-radius: 6px;
  transform: translateX(-50%) scaleX(0);
  transition: transform 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  z-index: 1;
  pointer-events: none;
}

.Recharge.animated::before {
  transform: translateX(-50%) scaleX(1);
}

.Recharge,
.Recharge>* {
  position: relative;
  z-index: 2;
}
</style>
